import { useMutation } from "@tanstack/vue-query"
import { axios } from "@/axios"

export interface IUnlockAlbumUseArgs {
  passcode: string
  eventVaultId: number
  albumId: number
}

export async function unlockAlbum(passcode: string, eventVaultId?: number, albumId?: number) {
  if (!eventVaultId)
    throw new Error("Missing Event Vault Id: Unable to call `unlockAlbum`.")
  if (!albumId)
    throw new Error("Missing Album Id: Unable to call `unlockAlbum`.")

  const unlockFields = new FormData()
  unlockFields.append("albumPasscode", passcode)

  await axios.post(`api/guest/${eventVaultId}/album/${albumId}/unlock`, unlockFields, {
    headers: { "Content-Type": "multipart/form-data" },
  })
}

const UNLOCK_ALBUM_KEY = "unlockAlbum"

export function useUnlockAlbum() {
  return useMutation({
    mutationKey: [UNLOCK_ALBUM_KEY],
    mutationFn: (args: IUnlockAlbumUseArgs) => unlockAlbum(args.passcode, args.eventVaultId, args.albumId),
  })
}
